import { Action } from '@ngrx/store';
import { PersonPreferenceInterface, UpdateTemplateInterface } from '../../+models';
import { CustomFeedbackHandlersInterface, FeedbackTriggeringAction } from '../effect-feedback';

export enum PersonPreferencesActionTypes {
  PersonPreferencesLoaded = '[PersonPreferences] PersonPreferences Loaded',
  PersonPreferencesLoadError = '[PersonPreferences] Load Error',
  StartAddPersonPreference = '[PersonPreferences] Start Add PersonPreference',
  AddPersonPreference = '[PersonPreferences] Add PersonPreference',
  StartDeletePersonPreference = '[PersonPreferences] Start Delete PersonPreference',
  DeletePersonPreference = '[PersonPreferences] Delete PersonPreference',
  StartUpsertPersonPreference = '[PersonPreferences] Start upsert PersonPreference',
  UpsertPersonPreference = '[PersonPreferences] Upsert PersonPreference',
  StartAddTemplate = '[PersonPreferences] Start Add Template',
  StartUpdateTemplate = '[PersonPreferences] Start Update Template',
  StartDuplicateTemplate = '[PersonPreferences] Start Duplicate Template',
  StartDeleteTemplate = '[PersonPreferences] Start Delete Template',
}

export class PersonPreferencesLoaded implements Action {
  readonly type = PersonPreferencesActionTypes.PersonPreferencesLoaded;

  constructor(public payload: { personPreferences: PersonPreferenceInterface[] }) {}
}

export class PersonPreferencesLoadError implements Action {
  readonly type = PersonPreferencesActionTypes.PersonPreferencesLoadError;
  constructor(public payload: any) {}
}

export class StartAddPersonPreference implements Action {
  readonly type = PersonPreferencesActionTypes.StartAddPersonPreference;

  constructor(
    public payload: {
      userId: number;
      personPreference: PersonPreferenceInterface;
      customFeedbackHandlers?: CustomFeedbackHandlersInterface;
    }
  ) {}
}

export class AddPersonPreference implements Action {
  readonly type = PersonPreferencesActionTypes.AddPersonPreference;

  constructor(public payload: { personPreference: PersonPreferenceInterface; navigateAfterCreate?: boolean }) {}
}

export class StartDeletePersonPreference implements FeedbackTriggeringAction {
  readonly type = PersonPreferencesActionTypes.StartDeletePersonPreference;

  constructor(
    public payload: {
      id: number;
      customFeedbackHandlers?: CustomFeedbackHandlersInterface;
      updateCompleteProfile?: boolean;
    }
  ) {}
}

// Removes the preference from the store once the api call has succeeded. Dispatch
// StartDeletePersonPreference (or StartDeleteTemplate) to actually delete one.
export class DeletePersonPreference implements Action {
  readonly type = PersonPreferencesActionTypes.DeletePersonPreference;

  constructor(public payload: { id: number }) {}
}

export class StartUpsertPersonPreference implements FeedbackTriggeringAction {
  readonly type = PersonPreferencesActionTypes.StartUpsertPersonPreference;

  constructor(
    public payload: {
      personPreference: PersonPreferenceInterface;
      customFeedbackHandlers?: CustomFeedbackHandlersInterface;
      noFeedBack?: boolean;
    }
  ) {}
}

export class UpsertPersonPreference implements FeedbackTriggeringAction {
  readonly type = PersonPreferencesActionTypes.UpsertPersonPreference;

  constructor(
    public payload: {
      personPreference: PersonPreferenceInterface;
      customFeedbackHandlers?: CustomFeedbackHandlersInterface;
    }
  ) {}
}

export class StartAddTemplate implements Action {
  readonly type = PersonPreferencesActionTypes.StartAddTemplate;

  constructor(
    public payload: {
      personPreference: PersonPreferenceInterface;
      customFeedbackHandlers?: CustomFeedbackHandlersInterface;
    }
  ) {}
}

export class StartUpdateTemplate implements Action {
  readonly type = PersonPreferencesActionTypes.StartUpdateTemplate;

  constructor(
    public payload: {
      id: number;
      changes: UpdateTemplateInterface;
      customFeedbackHandlers?: CustomFeedbackHandlersInterface;
    }
  ) {}
}

export class StartDuplicateTemplate implements Action {
  readonly type = PersonPreferencesActionTypes.StartDuplicateTemplate;

  constructor(
    public payload: {
      id: number;
      name: string;
      customFeedbackHandlers?: CustomFeedbackHandlersInterface;
    }
  ) {}
}

export class StartDeleteTemplate implements Action {
  readonly type = PersonPreferencesActionTypes.StartDeleteTemplate;

  constructor(
    public payload: {
      id: number;
      customFeedbackHandlers?: CustomFeedbackHandlersInterface;
    }
  ) {}
}

export type PersonPreferencesActions =
  | PersonPreferencesLoaded
  | PersonPreferencesLoadError
  | StartAddPersonPreference
  | StartDeletePersonPreference
  | DeletePersonPreference
  | StartUpsertPersonPreference
  | UpsertPersonPreference
  | AddPersonPreference
  | StartAddTemplate
  | StartUpdateTemplate
  | StartDuplicateTemplate
  | StartDeleteTemplate;
